import React from 'react';
import PropTypes from 'prop-types';
import ErgoDataForm from '../../components/ErgoDataForm';
import { formTypes } from '../../models/form';

const WitnessContactData = props => (
  <ErgoDataForm {...props} formType={formTypes.WITNESS} />
);

WitnessContactData.propTypes = {
  localePath: PropTypes.string,
  isValid: PropTypes.bool,
  buttonText: PropTypes.string,
};

WitnessContactData.defaultProps = {
  localePath: '',
  isValid: true,
  buttonText: '',
};

WitnessContactData.contextTypes = {
  t: PropTypes.func,
};

export default WitnessContactData;
